import ReportsService from '@/services/ReportsService.js'
const namespaced = true
const state = {
    code: '',
    error: '',
    overview: '',
    excel: ''

}
const mutations = {
    SET_OVERVIEW(state, list) {
        state.overview = list
    },
    SET_OVERALL(state, list) {
        state.excel = list
    }
}
const actions = {
    fetchOverviewLists({
        commit,
        rootState
    }, {
        page,
        show,
        sort,
        label,
        query
    }) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return ReportsService.app.postGstFilingOverview(page, show, sort, label, rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_OVERVIEW', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchOverallLists({
        commit,
        rootState
    }, {
        query
    }) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return ReportsService.app.postGstFilingOverall(rootState.session.token, query)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_OVERALL', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    }
}
export default {
    namespaced,
    state,
    mutations,
    actions
}